module.exports = "<header class=\"wrapper\">\n<h1>{{ title }}</h1> \n</header>"